import { Button } from "@/components/ui/button";
import {
	Dialog,
	DialogContent,
	DialogFooter,
	DialogHeader,
	DialogTitle,
} from "@/components/ui/dialog";
import {
	Form,
	FormControl,
	FormField,
	FormItem,
	FormLabel,
	FormMessage,
} from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { UseFormReturn } from "react-hook-form";

function ForgotPasswordDialog({
	form,
	onSubmit,
	showForgotPasswordDialog,
	setShowForgotPasswordDialog,
}: {
	form: UseFormReturn<{ email: string }>;
	onSubmit: (data: { email: string }) => Promise<void>;
	showForgotPasswordDialog: boolean;
	setShowForgotPasswordDialog: (open: boolean) => void;
}) {
	return (
		<Dialog
			open={showForgotPasswordDialog}
			onOpenChange={setShowForgotPasswordDialog}
		>
			<DialogContent>
				<DialogHeader>
					<DialogTitle>Forgot password</DialogTitle>
				</DialogHeader>
				<Form {...form}>
					<form onSubmit={form.handleSubmit(onSubmit)}>
						<FormField
							control={form.control}
							name="email"
							render={({ field }) => (
								<FormItem>
									<FormLabel>Email address</FormLabel>
									<FormControl>
										<Input
											{...field}
											required
											type={"email"}
											placeholder="Email"
											className="bg-light-input"
										/>
									</FormControl>
									<FormMessage />
								</FormItem>
							)}
						/>

						<DialogFooter>
							<Button type="submit" className="mt-12 w-75">
								Send reset link
							</Button>
						</DialogFooter>
					</form>
				</Form>
			</DialogContent>
		</Dialog>
	);
}

export default ForgotPasswordDialog;
